import apiClient from './apiClient'


const getContractReceivers = (tenant) => {
  return apiClient.get(`/${tenant}/ContractReceiver`)
}

const getContractReceiver = (tenant, id) => {
  return apiClient.get(`/${tenant}/ContractReceiver/${id}`)
}

const createContractReceiver = (tenant, receiverIds) => {
  return apiClient.post(`/${tenant}/ContractReceiver`, receiverIds)
}

const deleteContractReceiver = (tenant, id) => {
  return apiClient.delete(`/${tenant}/ContractReceiver/${id}`)
}


export default {
  getContractReceivers,
  getContractReceiver,
  createContractReceiver,
  deleteContractReceiver
}
